// extracted by mini-css-extract-plugin
export default {"page":"CheckoutPage_page__RLeW-"};